import { ConfigProvider, Spin } from 'antd';
import _ from 'lodash-es';
import React, { Fragment } from 'react';
import intl from 'react-intl-universal';
import { BrowserRouter, Route, Routes } from "react-router-dom";

import './libs/ApiUrl';
import I18n from './libs/I18n';
import VisitHelper from './libs/VisitHelper';
import { DynamicFlows } from './views/Workflows';
import Themes from './styles/Themes';

export default class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ready: false,
            theme: Themes.get("base")
        };

        this.initParams();
        if (process.env.NODE_ENV !== "development") {
            this.extractWebroot();
        }
    }

    initParams() {
        if (process.env.NODE_ENV === "development") {
            // This is for testing locally
            if (!window.user) {
                // window.user = {
                //     token: "ea88b3fbc639f07d320d72ed772bc8a6"
                // }
            }
        }
        const query = new URLSearchParams(window.location.search);
        var queryAccountCode = query.get("account_code");
        if (queryAccountCode) {
            _.set(window, 'CONFIG.Account.code', queryAccountCode);
        }
        if (query.get("token")) {
            _.set(window, 'user.token', query.get("token"));
        }
        if (!_.get(window, 'user.token')) {
            _.set(window, 'user.token', _.get(window, 'CONFIG.Account.waiting_room.visits.appointment_v2.guest_user'));
        }
    }

    extractWebroot() {
        // We may consider to move the function to common lib
        // 1. Calculate EKS base url
        var matches = window.location.href.match("https://([^/]+)(/[^/]+)?/pages/workflows");
        if (matches.length > 2) {
            window.eks_webroot = matches[2] ? matches[2] : "";
        }

        // 2. Calculate api_v3 base url
        // Rules:
/*
 *+-------------------------------------------------------+-------------------------------------------------+
 *| Page Url                                              | api_v3 endpoint                                 |
 *+-------------------------------------------------------+-------------------------------------------------+
 *| https://api.vsee.io/pages/workflows                   | https://api.vsee.io/api_v3                      |
 *| https://api.vsee.io/{dev/next/ligeng}/pages/workflows | https://api.vsee.io/vc/{dev/next/ligeng}/api_v3 |
 *| https://api-ms.vsee.me/pages/workflows                | https://api.vsee.me/api_v3                      |
 *| https://api-ms.vsee.me/next/pages/workflows           | https://api.vsee.me/next_php81/api_v3           |
 *+-------------------------------------------------------+-------------------------------------------------+
 */
        // If the page is hosted in EKS, the page url will be api-ms.vsee.me. But api_v3 request
        // uses api.vsee.me
        var groups = window.location.href.match(/(https:\/\/[^/]+)(\/[^/]+)?\/pages\/workflows/);
        var webroot = "";
        var apiDomain = "";
        if (groups && groups.length > 1) {
            if (groups[1].indexOf("vsee.io") > -1) {
                // Dev env
                webroot = (groups.length > 2) ? "/vc" + groups[2] : "";
                apiDomain = "https://api.vsee.io";
            } else if (groups[1].indexOf("vsee.me") > -1) {
                // Prod env
                webroot = (groups.length > 2 && groups[2]) ? groups[2] : "";
                apiDomain = "https://api.vsee.me";
            }
            window.webroot = webroot ? webroot : "";
            window.base_url = apiDomain + webroot;
        }
    }

    loadTheme() {
        var theme = this.state.theme;
        if (_.get(window, "CONFIG.Account.theme.code")) {
            theme = Themes.get(window.CONFIG.Account.theme.code);
        }
        if (_.get(window, "CONFIG.Account.theme.main_color")) {
            theme["token"]["colorPrimary"] = window.CONFIG.Account.theme.main_color;
            theme["token"]["colorLink"] = window.CONFIG.Account.theme.main_color;
        }
        this.setState({theme: theme});
    }

    loadSetting() {
        var headers = {
            'Content-Type': 'application/json'
        };
        if (_.get(window, "user.token")) {
            headers["X-ApiToken"] = window.user.token;
        }
        if (_.get(window, "CONFIG.Account.code")) {
            headers["X-AccountCode"] = window.CONFIG.Account.code;
        }
        fetch(window.base_url + "/api_v3/pages/systems_config", {
            credentials: 'omit',
            headers: headers
        }).then(response => response.json()).then(({data}) => {
            window.CONFIG = JSON.parse(data.CONFIGJson);
            window.CONST = JSON.parse(data.CONSTJson);
            window.SYSTEM_CONFIG = JSON.parse(data.systemConfigJson);
            window.auth_code = JSON.parse(data.authCode);
            window.role_text = data.role_text;
            if (data.roles) {
                window.roles = data.roles;
            }
            window.app = data.app;
            window.user = {
                ...window.user,
                ...data.user
            };
            window.app = data.app;

            window.ApiUrl.init(window.CONFIG);
            this.initParams();

            intl.init({
                currentLocale: window.app.lang,
                locales: {
                    [window.app.lang]: I18n.vc()
                }
            });
            this.loadTheme();
            window.base_url = _.get(window.CONFIG, "Account.reactjs.api_v3.base_url", window.base_url);
            window.webroot = _.get(window.CONFIG, "Account.reactjs.api_v3.webroot", window.webroot);
            this.setState({ready: true});
        }).catch(() => {
            window.location = window.base_url + "/admin/users/login";
        });
    }

    componentDidMount() {
        this.loadSetting();
    }

    render() {
        const rootPath = (process.env.NODE_ENV === "development") ? "/pages/workflows" : window.eks_webroot + "/pages/workflows";
        return (
            <Fragment>
                <style>{`
                    :root {
                        --main-color: ${Themes.getPrimaryColor()}
                    }
                `}</style>
                {(this.state.ready) ? (
                    <ConfigProvider
                        direction={VisitHelper.is_RTL_layout() ? "rtl" : "ltr"}
                        theme={this.state.theme}
                    >
                        <BrowserRouter basename={rootPath}>
                            <Routes>
                                <Route path="/" element={<DynamicFlows/>}/>
                                <Route path="/:workflow_id" element={<DynamicFlows/>}/>
                            </Routes>
                        </BrowserRouter>
                    </ConfigProvider>
                ) : (
                    <div
                        className="is-spinning-loading"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100vh",
                        }}
                    >
                        <Spin size="large"/>
                    </div>
                )}
            </Fragment>
        )
    }
}
